import { UserCompanyGroupApi } from './userCompanyGroupApi'

export const UserCompanyGroupService = {
    list: (userEmail) => UserCompanyGroupApi.list((userEmail)).then(response => response.data),
}
